import { gql } from "apollo-boost";

export const ADD_NEW_RANK = gql`
mutation rankMerge($rankId: Int, $rankCode: String!, $rankName: String!, $rankDesc: String!, $rankClassification: String, $rankColor: String, $rankLogo: String, $updateSource: String!) {
  rankMerge(programData: {rankId: $rankId, rankCode: $rankCode, rankName: $rankName, rankDesc: $rankDesc, rankClassification: $rankClassification, rankColor: $rankColor, rankLogo: $rankLogo, updateSource: $updateSource}) {
    edges {
      node {
        rankId
        rankCode
        rankName
        rankDesc
        rankLogo
        rankColor
        rankClassification
        updateSource
        updateDate
      }
    }
  }
}

`;

export const DELETE_CURRENT_RANK = gql`
  mutation rankDelete($rankId: Int!) {
    rankDelete(rankId: $rankId) {
      status
    }
  }
`;
